import { render, staticRenderFns } from "./RegularBuyBoxNew.vue?vue&type=template&id=88df334c&scoped=true"
import script from "./RegularBuyBoxNew.vue?vue&type=script&setup=true&lang=ts"
export * from "./RegularBuyBoxNew.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RegularBuyBoxNew.vue?vue&type=style&index=0&id=88df334c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88df334c",
  null
  
)

export default component.exports